/* AQUALUX — JavaScript propio (sin librerías). Cada componente comprueba que existe antes de actuar. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function sharedObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          el.classList.add('aq-visible');
          if (el.hasAttribute('data-aq-count')) runCounter(el);
          if (el.hasAttribute('data-aq-compare-hint')) runHint(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    return io;
  }

  /* ---------- Reveal + observados ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.aq-reveal:not([data-aq-seen]), [data-aq-count]:not([data-aq-seen]), [data-aq-compare-hint]:not([data-aq-seen])');
    var obs = sharedObserver();
    els.forEach(function (el) {
      el.setAttribute('data-aq-seen', '1');
      if (!obs || reduceMotion) {
        el.classList.add('aq-visible');
        if (el.hasAttribute('data-aq-count')) finishCounter(el);
        return;
      }
      obs.observe(el);
    });
  }

  /* ---------- Cifras animadas ---------- */
  function formatNumber(value, decimals) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
  }
  function counterParts(el) {
    var raw = String(el.getAttribute('data-aq-count')).replace(',', '.');
    var target = parseFloat(raw);
    var decimals = raw.indexOf('.') > -1 ? raw.split('.')[1].length : 0;
    return { target: isNaN(target) ? 0 : target, decimals: decimals };
  }
  function finishCounter(el) {
    var p = counterParts(el);
    var out = el.querySelector('[data-aq-count-out]') || el;
    out.textContent = formatNumber(p.target, p.decimals);
  }
  function runCounter(el) {
    var p = counterParts(el);
    var out = el.querySelector('[data-aq-count-out]') || el;
    var duration = 1600;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      out.textContent = formatNumber(p.target * eased, p.decimals);
      if (t < 1) requestAnimationFrame(tick);
      else out.textContent = formatNumber(p.target, p.decimals);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Comparador antes / después ---------- */
  function setPos(el, v) {
    el.style.setProperty('--pos', v + '%');
  }
  function runHint(el) {
    var range = el.querySelector('.aq-compare__range');
    if (!range || reduceMotion) return;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var t = Math.min((ts - start) / 2200, 1);
      var v = 50 - Math.sin(t * Math.PI * 2) * 22 * (1 - t * 0.3);
      setPos(el, v);
      range.value = v;
      if (t < 1) requestAnimationFrame(tick);
      else {
        setPos(el, 50);
        range.value = 50;
      }
    }
    requestAnimationFrame(tick);
  }
  function initCompare(root) {
    root.querySelectorAll('[data-aq-compare]:not([data-aq-init])').forEach(function (el) {
      el.setAttribute('data-aq-init', '1');
      var range = el.querySelector('.aq-compare__range');
      if (!range) return;
      setPos(el, range.value);
      range.addEventListener('input', function () {
        setPos(el, range.value);
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-aq-gallery]:not([data-aq-init])').forEach(function (g) {
      g.setAttribute('data-aq-init', '1');
      var main = g.querySelector('[data-aq-main]');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-aq-thumb]'));
      if (!main || !thumbs.length) return;
      var index = 0;
      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        var t = thumbs[index];
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (x) {
          x.setAttribute('aria-current', x === t ? 'true' : 'false');
        });
        if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          show(i);
        });
      });
      var prev = g.querySelector('[data-aq-prev]');
      var next = g.querySelector('[data-aq-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      var startX = null;
      main.parentNode.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.parentNode.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      });
    });
  }

  /* ---------- Formulario de producto (variantes, cantidad, barra fija) ---------- */
  var moneyFormat = '{{amount}}';
  function money(cents) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      n = (n / 100).toFixed(precision);
      var p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (p[1] ? decimal + p[1] : '');
    }
    var m = moneyFormat.match(re);
    var kind = m ? m[1] : 'amount';
    var value;
    switch (kind) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return moneyFormat.replace(re, value);
  }
  function initProduct(root) {
    root.querySelectorAll('[data-aq-product]:not([data-aq-init])').forEach(function (box) {
      box.setAttribute('data-aq-init', '1');
      moneyFormat = box.getAttribute('data-money-format') || moneyFormat;
      var form = box.querySelector('form');
      var dataEl = box.querySelector('[data-aq-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
      var idInput = box.querySelector('input[name="id"]');
      var priceEl = box.querySelectorAll('[data-aq-price]');
      var compareEl = box.querySelector('[data-aq-compare-price]');
      var submits = document.querySelectorAll('[data-aq-submit="' + box.getAttribute('data-aq-product') + '"]');
      var soldText = box.getAttribute('data-sold-text') || 'Agotado';
      var addText = box.getAttribute('data-add-text') || 'Añadir al carrito';
      var stock = box.querySelector('[data-aq-stock]');

      function apply(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceEl.forEach(function (el) { el.textContent = money(v.price); });
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price);
            compareEl.hidden = false;
          } else compareEl.hidden = true;
        }
        submits.forEach(function (b) {
          b.disabled = !v.available;
          var label = b.querySelector('[data-aq-label]');
          if (label) label.textContent = v.available ? addText : soldText;
        });
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          stock.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      if (variants.length > 1) {
        box.querySelectorAll('.aq-opt input').forEach(function (input) {
          input.addEventListener('change', function () {
            var selected = [];
            box.querySelectorAll('.aq-opt').forEach(function (fs) {
              var checked = fs.querySelector('input:checked');
              selected.push(checked ? checked.value : null);
            });
            var match = variants.filter(function (v) {
              return selected.every(function (val, i) { return val === null || v.options[i] === val; });
            })[0];
            apply(match);
          });
        });
      }

      var qty = box.querySelector('.aq-qty input');
      box.querySelectorAll('[data-aq-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          var n = parseInt(qty.value, 10) || 1;
          n += parseInt(btn.getAttribute('data-aq-qty'), 10);
          qty.value = Math.max(1, Math.min(99, n));
        });
      });

      var bar = document.querySelector('[data-aq-sticky="' + box.getAttribute('data-aq-product') + '"]');
      var anchor = box.querySelector('[data-aq-buy]');
      if (bar && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(anchor);
      }
    });
  }

  /* ---------- Cabecera ---------- */
  function initHeader(root) {
    root.querySelectorAll('.aq-header:not([data-aq-init])').forEach(function (h) {
      h.setAttribute('data-aq-init', '1');
      var burger = h.querySelector('[data-aq-burger]');
      function onScroll() { h.classList.toggle('is-scrolled', window.scrollY > 8); }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      if (burger) {
        burger.addEventListener('click', function () {
          var open = h.classList.toggle('is-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        h.querySelectorAll('.aq-mobile-menu a').forEach(function (a) {
          a.addEventListener('click', function () {
            h.classList.remove('is-open');
            burger.setAttribute('aria-expanded', 'false');
          });
        });
      }
    });
  }

  function initAll(root) {
    initReveal(root);
    initCompare(root);
    initGallery(root);
    initProduct(root);
    initHeader(root);
  }

  function boot() {
    initAll(document);
    window.__aqReady = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    e.target.querySelectorAll('.aq-reveal').forEach(function (el) { el.classList.add('aq-visible'); });
    e.target.querySelectorAll('[data-aq-count]').forEach(finishCounter);
  });
})();
